// extracted by mini-css-extract-plugin
export default {"icon":"zqO9h","opened":"YXhzw","content":"uvlgI","link":"zhFS3"};